import { render, staticRenderFns } from "./incidenceTable.vue?vue&type=template&id=717498ae&scoped=true"
import script from "./incidenceTable.vue?vue&type=script&lang=js"
export * from "./incidenceTable.vue?vue&type=script&lang=js"
import style0 from "./incidenceTable.vue?vue&type=style&index=0&id=717498ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717498ae",
  null
  
)

export default component.exports